import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { PremissasService } from '../services/premissas.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { FornecedorService } from '../services/fornecedor.service';

@Component({
  selector: 'app-relatorios',
  templateUrl: './relatorios.component.html',
  styleUrls: ['./relatorios.component.scss']
})
export class RelatoriosComponent implements OnInit {
  administrador = false;
  fidelidadeGoSolar = false;
  pCentroDistribuicao = false;
  cds = [];

  constructor(
    private router: Router,
    private globalService: GlobalService,
    private premissasService: PremissasService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private fornecedorService: FornecedorService
  ) { }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    await this.buscarPremissaCentroDeDistribuicao();
  }

  abrirRelatorioGoMais() {
    this.router.navigate(['relatorio-gomais']);
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');

      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;

      if (this.pCentroDistribuicao) {
        await this.buscarCDs();
      }

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarCDs() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarCDs');

      this.fornecedorService.consultarFornecedores().subscribe(
        (forn) => {
          this.cds = forn;
          this.carregandoService.esconde('buscarCDs');
          resolve();
        },
        (err) => {
          this.carregandoService.esconde('buscarCDs');
          this.notificacaoService.erro(err);
          reject();
        }
      );
    });
  }
}
